module.exports = __webpack_public_path__ + "static/img/qr-code-4.aaad81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-4.png
// module id = V0u+
// module chunks = 0